import React from "react";
import styled from "styled-components";
import { useStaticQuery, graphql } from "gatsby";
import { Link } from "gatsby";

import visa from "../../../content/assets/icons/visa-logo.svg";
import mastercard from "../../../content/assets/icons/mastercard-logo.svg";
import mir from "../../../content/assets/icons/mir-logo.svg";
import alfa from "../../../content/assets/icons/alfabank-logo.svg";
import renaissance from "../../../content/assets/icons/renaissance-logo.svg";

const Footer = styled.footer`
  width: 100%;
  display: flex;
  height: 100%;
  flex-direction: column;
  background-color: #f4f4f4;
`;
const Nav = styled.nav`
  margin-top: 12px;
  display: flex;
  justify-content: space-between;
  flex: 1;
  font-weight: bold;
  @media (max-width: 768px) {
    flex-direction: column;
    text-align: left;
  }
  .active {
    text-decoration: underline;
    text-underline-position: under;
  }
`;

const FooterItems = styled.div`
  width: 100%;
  display: flex;
  align-items: left;
  justify-content: space-between;
  flex-wrap: wrap;
  margin: 35px 0;
  @media (max-width: 768px) {
    text-align: center;
    flex-direction: column;
  }
  p {
    font-family: Montserrat, Arial, sans-serif;
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    line-height: 21px;
    color: #878f9d;
  }
  span {
    color: #ffad0d;
  }
`;

const Item = styled.div`
  flex-grow: 1;
  min-width: 200px;
  display: flex;
  flex-direction: column;
  justify-content: center;

  height: 100%;
  p {
    font-family: DINPro;
    font-size: 18px;
    line-height: 21px;
    display: flex;
    align-items: center;
    color: #555555;
    margin: 0;
  }
`;

const SubItem = styled.div`
  min-width: 120px;
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  img {
    height: 45px;
    width: 45px;
    margin: 0 24px 0 0;
  }
  img.renaissance-logo {
    width: 100px;
  }
  p {
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    line-height: 15px;
    display: flex;
    align-items: center;
    color: #b6b6b6;
    margin: 0;
  }
`;
// const data = useStaticQuery(
//   graphql`
//     query {
//       site {
//         siteMetadata {
//           twitter,
//           facebook,
//           vk,
//           instagram
//         }
//       }
//     }
//   `
// )

export default () => (
  <Footer>
    <div className="container">
      <Nav>
        <Link to="/about" activeClassName="active">
          О компании
        </Link>
        <Link to="/partners" activeClassName="active">
          Партнерам
        </Link>
        <Link to="/documents" activeClassName="active">
          Документы
        </Link>
        <Link to="/requisites" activeClassName="active">
          Реквизиты
        </Link>
        <Link to="/information" activeClassName="active">
          Оплата и доставка
        </Link>
        <Link to="/questions" activeClassName="active">
          Частые вопросы
        </Link>
      </Nav>
      <FooterItems>
        <Item>
          <p>
            <a href="https://www.instagram.com/moishlem/">Instagram</a>,&nbsp;
            <a href="https://www.facebook.com/moishlem">Facebook</a>,&nbsp;
            <a href="https://vk.com/moishlem">VK</a>,&nbsp;
            <a href="https://twitter.com/moishlem">Twitter</a>
          </p>
          <p>© 2016—2020 ООО «Мой Шлем»</p>
          <p>Все права защищены </p>
        </Item>
        <Item>
          <p>Страховые услуги предоставлены:</p>
          <SubItem>
            <img
              className="renaissance-logo"
              src={renaissance}
              alt="visa card"
            />
            <Item>
              <p>ООО «Группа Ренессанс Страхование»,</p>
              <p>лицензия ЦБ РФ СЛ № 1284 от 14.10.2015 г.</p>
            </Item>
          </SubItem>
        </Item>
        <Item>
          <p>Мы принимаем:</p>
          <SubItem>
            <img src={visa} alt="visa card" />
            <img src={mastercard} alt="mastercard" />
            <img src={mir} alt="mir card" />
            <img src={alfa} alt="alfa card" />
          </SubItem>
        </Item>
      </FooterItems>
    </div>
  </Footer>
);
